/**
 * Head, Ear, Nose, Throat and Neck Examination Data Points
 * Category: HEENT
 */

export const heentDataPoints = [
  // Head & Neck
  {
    id: 'head_neck',
    label: 'Head & Neck',
    category: 'HEENT',
    subcategory: 'Head & Neck',
    fieldType: 'multi',
    isActive: true,
    options: ['Neck stiffness', 'Cervical Lymphadenopathy', 'Other'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: true,
      required: false,
      defaultValue: null,
      placeholder: 'Specify other head & neck findings...',
      helpText: 'Select head and neck examination findings'
    },
    code: '69536005', // SNOMED CT - Head structure
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Throat - Pharynx
  {
    id: 'pharynx',
    label: 'Pharynx',
    category: 'HEENT',
    subcategory: 'Throat',
    fieldType: 'multi',
    isActive: true,
    options: ['Normal', 'Swollen', 'Erythema', 'Ulceration', 'Exudates', 'Other'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: true,
      required: false,
      defaultValue: null,
      placeholder: 'Specify other pharynx findings...',
      helpText: 'Select pharynx examination findings'
    },
    code: '54066008', // SNOMED CT - Pharyngeal structure
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Throat - Tonsils
  {
    id: 'tonsils',
    label: 'Tonsils',
    category: 'HEENT',
    subcategory: 'Throat',
    fieldType: 'multi',
    isActive: true,
    options: ['Removed', 'Enlarged', 'Exudate', 'Other'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: true,
      required: false,
      defaultValue: null,
      placeholder: 'Specify other tonsil findings...',
      helpText: 'Select tonsil examination findings'
    },
    code: '75573002', // SNOMED CT - Tonsil structure
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Ears - Left External Auditory Meatus
  {
    id: 'left_external_auditory_meatus',
    label: 'Left - External Auditory Meatus',
    category: 'HEENT',
    subcategory: 'Ears',
    fieldType: 'multi',
    isActive: true,
    options: ['Clear', 'Inflamed', 'Cerumen', 'Other'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: true,
      required: false,
      defaultValue: null,
      placeholder: 'Specify other findings...',
      helpText: 'Left external auditory meatus examination findings'
    },
    code: '84301002', // SNOMED CT - External auditory meatus structure
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Ears - Left Tympanic Membrane
  {
    id: 'left_tympanic_membrane',
    label: 'Left - Tympanic Membrane',
    category: 'HEENT',
    subcategory: 'Ears',
    fieldType: 'multi',
    isActive: true,
    options: ['Clear', 'Inflamed', 'Other'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: true,
      required: false,
      defaultValue: null,
      placeholder: 'Specify other findings...',
      helpText: 'Left tympanic membrane examination findings'
    },
    code: '42859004', // SNOMED CT - Tympanic membrane structure
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Ears - Right External Auditory Meatus
  {
    id: 'right_external_auditory_meatus',
    label: 'Right - External Auditory Meatus',
    category: 'HEENT',
    subcategory: 'Ears',
    fieldType: 'multi',
    isActive: true,
    options: ['Clear', 'Inflamed', 'Cerumen', 'Other'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: true,
      required: false,
      defaultValue: null,
      placeholder: 'Specify other findings...',
      helpText: 'Right external auditory meatus examination findings'
    },
    code: '84301002', // SNOMED CT - External auditory meatus structure
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Ears - Right Tympanic Membrane
  {
    id: 'right_tympanic_membrane',
    label: 'Right - Tympanic Membrane',
    category: 'HEENT',
    subcategory: 'Ears',
    fieldType: 'multi',
    isActive: true,
    options: ['Clear', 'Inflamed', 'Other'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: true,
      required: false,
      defaultValue: null,
      placeholder: 'Specify other findings...',
      helpText: 'Right tympanic membrane examination findings'
    },
    code: '42859004', // SNOMED CT - Tympanic membrane structure
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Sinuses
  {
    id: 'sinuses',
    label: 'Sinuses',
    category: 'HEENT',
    subcategory: 'Sinuses',
    fieldType: 'multi',
    isActive: true,
    options: ['Non-tender', 'Tenderness'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Sinus examination findings'
    },
    code: '2095001', // SNOMED CT - Paranasal sinus structure
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
]

export default heentDataPoints
